import { render, staticRenderFns } from "./TheLayoutPageTitle.vue?vue&type=template&id=06d40e10&scoped=true&"
import script from "./TheLayoutPageTitle.vue?vue&type=script&lang=js&"
export * from "./TheLayoutPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutPageTitle.vue?vue&type=style&index=0&id=06d40e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d40e10",
  null
  
)

export default component.exports